import { useParams } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import DOMPurify from 'dompurify'

import i18n from 'modules/core/lib/i18n'

import { useActionWizard } from 'modules/processes/components/ItemWizard/Actions/ActionProvider'
import { useStepActionDescription } from 'modules/processes/components/ItemWizard/Actions/SendCustomEmail/useStepActionDescription'
import { ActionPreviewHeader } from 'modules/processes/components/ItemWizard/Actions/Steps/Preview/Header'
import { useFormProvider } from 'modules/processes/components/ItemWizard/Providers/form'
import { ProcessCategories } from 'modules/processes/domain'
import { assigneeSelectionTypes } from 'modules/processes/lib/assigneeTypeSubOptions'

export const Preview = () => {
  const { configuration } = useActionWizard()
  const { form } = useFormProvider()
  const { category } = useParams()

  const assigneeStrategy = form?.get('assignee_strategy').value

  const assigneeStrategies = assigneeSelectionTypes((category as ProcessCategories) || 'custom')

  const strategyLabel = assigneeStrategies.find((strategy) => strategy.value === assigneeStrategy)
  const description = useStepActionDescription()

  return (
    <>
      <ActionPreviewHeader
        description={i18n.t('processes.process_settings.actions.automatic_email.description')}
      />
      <Box paddingTop="s24">
        <Box
          padding="s24"
          gap="s8"
          borderRadius={{ all: 'abs016' }}
          border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
        >
          <PreviewText
            label={i18n.t('processes.process_settings.actions.automatic_email.recipient')}
            description={strategyLabel?.label || ''}
          />
          <PreviewText
            label={i18n.t('processes.process_settings.actions.automatic_email.subject.title')}
            description={configuration?.subject || ''}
          />

          <PreviewText
            label={i18n.t('processes.process_settings.actions.automatic_email.trigger')}
            description={description}
          />
          <Box
            padding="s24"
            gap="s2"
            borderRadius={{ all: 'abs008' }}
            background="grey100"
            border={{ all: { width: 's2', color: 'grey400', style: 'solid' } }}
          >
            <Text.Normal>
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(configuration?.body),
                }}
              />
            </Text.Normal>
          </Box>
        </Box>
      </Box>
    </>
  )
}

interface PreviewTextProps {
  label: string
  description: string
}

const PreviewText = ({ label, description }: PreviewTextProps) => {
  return (
    <Box paddingY="s4" gap="s4">
      <Text.Normal color="grey800" size="200">
        {label}
      </Text.Normal>
      <Text.Normal color="grey1000" weight="medium">
        {description}
      </Text.Normal>
    </Box>
  )
}
